<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12"
               v-if="$store.state.uuid"
               sm="3">
          <mrc_ess_switch :true-value="1"
                          :false-value="0"
                          v-model="params.is_used"
                          @change="paramsChange"
                          :readonly="readonly"
                          :true-text="$t('label_To_enable_the')"
                          :false-text="$t('label_disable')"></mrc_ess_switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
               sm="6">
          <mrc_ess_multiText :label="$t('label_role_name') + '*'"
                             :isNational="judegNational('role_name')"
                             :readonly="readonly"
                             @change="paramsChange"
                             style="width:100%"
                             :error-messages="
              $errors('params', 'role_name', requiredRule.concat(nocharacter))
            "
                             v-model="params.role_name"></mrc_ess_multiText>
          <!-- <v-text-field :error-messages="$errors('params','role_name',requiredRule.concat(maxLength(20)))"
                          @input="$v.params.role_name.$touch()"
                          @blur="$v.params.role_name.$touch()"
                          :readonly="disabled"
                          :label="$t('label_role_name')+'*'"
                          @change="paramsChange"
                          append-icon="mdi-longitude"
                          v-model="params.role_name"></v-text-field> -->
        </v-col>

        <v-col cols="12"
               sm="6">
          <!-- 角色短编码 -->
          <mrc_ess_multiText :label="$t('label_code') + '*'"
                             :isNational="judegNational('role_short_code')"
                             :readonly="readonly"
                             @change="paramsChange"
                             style="width:100%"
                             :error-messages="
              $errors('params', 'role_short_code', requiredRule)
            "
                             v-model="params.role_short_code"></mrc_ess_multiText>
        </v-col>

        <v-col cols="12"
               sm="6">
          <!-- <mrc_ess_prompt :errMsg="$errors('params', 'org_level_uuid', requiredRule)"
                          @getData="paramsChange"
                          :disabled="readonly"
                          value_field="uuid"
                          :rules="false"
                          :label="$t('label_company') + '*'"
                          :chips="false"
                          :obj="unitObj"
                          v-model="params.org_level_uuid">
          </mrc_ess_prompt> -->

          <mrc_ess_autoComplete :label="$t('label_company') + '*'"
                                orgView
                                :errorMessages="$errors('params', 'org_level_uuid', requiredRule)"
                                :readonly="readonly"
                                @changeStaff="paramsChange"
                                v-model="params.org_level_uuid"
                                :prompt_name="unitObj">
          </mrc_ess_autoComplete>
        </v-col>

        <v-col cols="12"
               sm="6">
          <!-- <v-text-field :error-messages="$errors('params','role_description',maxLength(70))"
                          @input="$v.params.role_description.$touch()"
                          @blur="$v.params.role_description.$touch()"
                          @change="paramsChange"
                          :readonly="disabled"
                          :label="$t('label_role_describe')"
                          append-icon="mdi-longitude"
                          v-model="params.role_description"></v-text-field> -->
          <mrc_ess_multiText :error-messages="$errors('params', 'role_description', nocharacter)"
                             @change="paramsChange"
                             noRequired
                             :isNational="judegNational('role_description')"
                             style="width:100%"
                             :readonly="readonly"
                             :label="$t('label_role_describe')"
                             v-model="params.role_description"></mrc_ess_multiText>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_datePicker :errMsg="
              $errors(
                'params',
                'effective_start_date',
                requiredRule.concat([
                  {
                    rule: 'beforeData',
                    msg: $t('verify_The_date_was_filled_in_incorrectly'),
                  },
                ])
              )
            "
                              @blur="$v.params.effective_start_date.$touch()"
                              @getTime="paramsChange"
                              afterDate
                              :disabled="readonly"
                              :label="$t('label_effective_start_date') + '*'"
                              v-model="params.effective_start_date"></mrc_ess_datePicker>
        </v-col>
        <v-col cols="12"
               sm="6">
          <mrc_ess_datePicker :errMsg="
              $errors('params', 'effective_end_date', [
                {
                  rule: 'afterData',
                  msg: $t('verify_The_date_was_filled_in_incorrectly'),
                },
              ])
            "
                              @blur="$v.params.effective_end_date.$touch()"
                              @getTime="paramsChange"
                              :disabled="readonly"
                              :placeholder="$t('label_effective_end_date')"
                              :label="$t('label_effective_end_date')"
                              v-model="params.effective_end_date"></mrc_ess_datePicker>
        </v-col>

        <v-col cols="12"
               sm="6">
          <!-- <v-text-field :error-messages="$errors('params','sequence',requiredRule.concat(between('1-99')))"
                          @input="$v.params.sequence.$touch()"
                          @blur="$v.params.sequence.$touch()"
                          @change="paramsChange"
                          :readonly="disabled"
                          :label="$t('label_The_sorting')+'*'"
                          v-model="params.sequence"></v-text-field> -->
          <mrc_ess_NumInput :readonly="readonly"
                            :error-messages="
              $errors(
                'params',
                'sequence',
                between('000-999').concat(requiredRule)
              )
            "
                            :label="$t('label_The_sorting') + '*'"
                            v-model="params.sequence"></mrc_ess_NumInput>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn @cancel="cancel"
                       v-if="!disabled"
                       @success="success"
                       :loading="loading"
                       :cancelText="cancelText || $t('label_cancel')"
                       :successText="successText || $t('label_submit')"></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    propsParams: {
      type: Object,
      default: () => { },
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
  },
  data () {
    return {
      date: "",
      params: {
        role_name: "",
        role_short_code: "",
        role_description: "",
        is_used: 1,
        org_level_uuid: "",
        sequence: 1,
        effective_start_date: null,
        effective_end_date: null,
        uuid: "",
      },
    }
  },
  validations: {
    params: {
      role_name: {
        required,
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      role_short_code: {
        required
      },
      role_description: {
        nocharacter (value) {
          return this.$myVerify.nocharacter(this.INT(value))
        },
      },
      effective_start_date: {
        required,
        beforeData (value) {
          if (!this.params.effective_end_date) return true
          const prevData = new Date(value).valueOf()
          const nextData = new Date(this.params.effective_end_date).valueOf()
          return prevData < nextData
        },
      },
      effective_end_date: {
        // required,
        afterData (value) {
          if (!this.params.effective_start_date) return true
          if (!this.params.effective_end_date) return true
          const nextData = new Date(value).valueOf()
          const prevData = new Date(this.params.effective_start_date).valueOf()
          return prevData < nextData
        },
      },
      org_level_uuid: {
        required,
      },
      sequence: {
        required,
        between: between(0, 999),
      },
    },
  },
  async created () {
    await this.national("mrbase_sys_role")
    if (this.propsParams) {
      this.params = this.propsParams
    }
  },
  mounted () { },
  methods: {
    paramsChange () {
      this.$emit("change", this.params)
    },
    cancel () {
      this.$emit("cancel")
    },
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit("success", this.params)
    },
  },
  computed: {
    readonly () {
      return this.params.uuid && this.$store.state.userData.type == "001"
        ? true
        : this.disabled
    },
    // 单位多选
    org_level_uuidArr: {
      get () {
        let arr = []
        if (this.params.org_level_uuid) {
          arr = this.params.org_level_uuid.split(",")
        }
        return arr
      },
      set (val) {
        this.params.org_level_uuid = val.join()
      },
    },
    unitObj () {
      let obj = {}
      switch (this.$store.state.userData.userType) {
        case 1:
          obj = { prompt_name: "org_level_for_clients" }
          break
        case 2:
          obj = {
            prompt_name: "org_levels_manager_filter_company_company",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          }
          break
        case 3:
          obj = {
            prompt_name: "org_levels_manager_filter_company_company",
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          }
          break
        default:
          obj = {
            prompt_name: "org_levels_manager_filter_company_other",
            user_id: this.$store.state.userData.user_id,
            client_uuid: this.$store.state.userData.clientUuid,
          }
      }
      return obj
    },
  },
  watch: {
    propsParams: {
      handler (val) {
        this.params = val
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
